import { AppListingTabs } from '@atlassian/mpac-app-listing';
import { AppListingTab } from '@atlassian/mpac-types';
import { stringify } from 'query-string';

import { AllHostingTypeQueryParams } from '../../../../../../../constants';

import type { GetMarketplacePluginByAppKeyQuery } from '../queries.gql.types';
import type { AppListingTabsType } from '@atlassian/mpac-types';
import type { useParams } from '@atlassian/mpac-ui';
import type { Location } from 'react-router';

type App = NonNullable<GetMarketplacePluginByAppKeyQuery['marketplaceAppByKey']>;

type GetRouteToRedirectToParams = {
  app: App;
  params: ReturnType<typeof useParams>;
};

export const getRouteToRedirectTo = ({ app, params }: GetRouteToRedirectToParams): Location => {
  const pathname = `/apps/${app.appId}/${app.slug}`;
  const search = stringify({
    ...(AllHostingTypeQueryParams.includes(params.hosting as string) && {
      hosting: params.hosting,
    }),
    tab: AppListingTabs.includes(params.tab as AppListingTabsType)
      ? params.tab
      : AppListingTab.Overview,
  });

  return { pathname, search };
};
